module.exports = __webpack_public_path__ + "fonts/fa-brands-400.198bce066a584daf3b208be81eb7f800.ttf";